import n from "./index810.js";
import t from "./index811.js";
function f(a, r) {
  return a != null && t(a, r, n);
}
export {
  f as default
};
